// extracted by mini-css-extract-plugin
module.exports = {"container":"related-products-module__container___2C-wS","wrap":"related-products-module__wrap___2gE93","title":"related-products-module__title___gxEVC"};